import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, HostBinding, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonDimensions } from 'src/app/models/collection.interface';
import { CollectionsService } from 'src/app/services/collections.service';
import { Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-libraries-selected-document-menu',
  standalone: true,
  imports: [MatIconModule, MatButtonModule],
  templateUrl: './libraries-selected-document-menu.component.html',
  styleUrl: './libraries-selected-document-menu.component.scss',
  animations: [
    trigger('slideInOut', [
      state(
        'in',
        style({
          transform: 'translateY(0)' // Fully visible
        })
      ),
      state(
        'out',
        style({
          transform: 'translateY(100%)' // Hidden below the screen
        })
      ),
      transition('in => out', animate('300ms ease-in-out')), // Animation when closing
      transition('out => in', animate('300ms ease-in-out')) // Animation when opening
    ])
  ]
})
export class LibrariesSelectedDocumentsMenuComponent {
  @Input() selectedDocuments: CommonDimensions[] = [];
  @Input() visible = false;
  @Output() refreshCollections = new EventEmitter<void>();

  constructor(
    private snackBar: MatSnackBar,
    private collectionsService: CollectionsService,
    private dialog: MatDialog
  ) {}

  @HostBinding('@slideInOut')
  get slideInOutState() {
    return this.visible ? 'in' : 'out';
  }

  showNotImplementedSnackbar(): void {
    this.snackBar.open('Not implemented yet', 'Close', {
      duration: 3000
    });
  }

  copySelectedDocuments(): void {
    this.showNotImplementedSnackbar();
  }

  downloadSelectedDocuments(): void {
    this.showNotImplementedSnackbar();
  }
}
